export default __webpack_public_path__ + "static/media/image15tum.16eefbb3.jpg";